export default __webpack_public_path__ + "static/media/icon-logo.inline.3fcd01d7.svg";